import { Component, Input, OnInit } from "@angular/core";
import { RequestService } from "../../../services/request.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../../services/auth.service";
import { RequestModel } from "../../../models/request.model";
import { IErrorAlert } from "../../../interfaces/error.interface";
import {
  Approved,
  Accepted,
  Pending,
  Rejected,
} from "src/app/models/request-state.model";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { constants } from "../../../utils/constants";
import Swal from "sweetalert2";

@Component({
  selector: "app-request-detail",
  templateUrl: "./request-detail.component.html",
  styleUrls: ["./request-detail.component.css"],
})
export class RequestDetailComponent implements OnInit {
  
  @Input() error: IErrorAlert;

  loading: boolean;
  request: RequestModel;
  rejected: any;
  approved = false;
  accepted = false;
  sentReceipts = false;

  downloadUrl;

  paymentForm: FormGroup;
  paymentMethods: any[] = constants.rules.paymentMethods;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    public _request: RequestService,
    public _auth: AuthService,
    private _fb: FormBuilder
  ) {
    this._route.params.subscribe((params: any) => {
      this.request =
        params.operation === "search"
          ? (this.request = this._request.requestSearch?.filter(
              (req: RequestModel) => params.number === req.number
            )[0])
          : (this.request = this._request.requestHistory?.filter(
              (req: RequestModel) => params.number === req.number
            )[0]);
    });
    this.paymentForm = this._fb.group({
      paymentMethod: ["", Validators.required],
    });
  }

  ngOnInit(): void {
    if (!this.request) this._router.navigate([this._auth.user.getHomeUrl()]);
    this._request.setCurrentRequest(this.request);
    this.rejected = {
      rejected: false,
      alert: {
        type: "warning",
        width: "auto",
        message: "Se ha rechazado la solicitud " + this.request?.name
      },
    };
  }

  reject() {
    this.showRejectAlert().then((accepted: boolean) => {
      if (accepted) {
        this.error = null;
        this.loading = true;
        this._request
          .updateState(
            this.request,
            new Rejected(),
            this._auth.user
          )
          .subscribe(
            () => {
              this.request.transitionTo(new Rejected());
              this.rejected.rejected = true;
              this.approved = false;
              this.sentReceipts = false;
              this.loading = false;
              this.error = null;
            },
            (err: IErrorAlert) => {
              this.error = { ...err, width: "auto" };
              this.loading = false;
            }
          );
      }
    });
  }

  handleApproveAction() {
    // Si es Actualización de Remuneraciones, se debe pasar a Accepted sin método de pago. Si no, a Pending
    if (this.request.isRRBB()) {
      this.confirmWithoutPaymentMethod();
    } else {
      this.approve();
    }
  }

  approve() {
    this.error = null;
    this.loading = true;
    this._request
      .updateState(
        this.request,
        new Pending(),
        this._auth.user
      )
      .subscribe(
        () => {
          this.request.transitionTo(new Pending());
          this.approved = true;
          this.loading = false;
        },
        (err: IErrorAlert) => {
          this.error = { ...err, width: "auto" };
          this.loading = false;
        }
      );
  }

  sendReceipts() {
    // Validate amount
    let sumAmount = 0; 
    this.request.receipts.forEach((receipt) => sumAmount += receipt.amount )
    if (+parseFloat(sumAmount.toFixed(2)) !== this.request.amount) {
      this.error = constants.alerts.receipts.nonMatchingAmounts;
      return;
    }

   
    
    this.error = null;
    this.loading = true;
    this._request
      .updateState(
        this.request,
        new Approved(),
        this._auth.user
      )
      .subscribe(
        () => {
          this.request.transitionTo(new Approved());
          this.sentReceipts = true;
          this.loading = false;
          this.error = null;
        },
        (err: IErrorAlert) => {
          this.error = { ...err, width: "auto" };
          this.loading = false;
        }
      );
  }

  private confirmWithoutPaymentMethod() {
    this.error = null;
    this.loading = true;
    this._request
      .updateState(
        this.request,
        new Accepted(),
        this._auth.user
      )
      .subscribe(
        () => {
          this.request.transitionTo(new Accepted());
          this.accepted = true;
          this.sentReceipts = false;
          this.loading = false;
        },
        (err: IErrorAlert) => {
          this.error = { ...err, width: "auto" };
          this.sentReceipts = false;
          this.loading = false;
        }
      );
  }

  confirmWithPaymentMethod() {
    this.error = null;
    this.loading = true;
    this._request
      .confirmRequest(
        this.request,
        parseInt(this.paymentForm.get("paymentMethod").value),
        this._auth.user
      )
      .subscribe(
        () => {
          this.request.transitionTo(new Accepted());
          this.request.setPaymentMethod(
            parseInt(this.paymentForm.get("paymentMethod").value)
          );
          this.accepted = true;
          this.sentReceipts = false;
          this.loading = false;
        },
        (err: IErrorAlert) => {
          this.error = { ...err, width: "auto" };
          this.sentReceipts = false;
          this.loading = false;
        }
      );
  }

  downloadRequest() {
    this.loading = true;
    this._request.downloadRequestFile(this.request).subscribe(
      (url: string) => {
        document.getElementById("download").setAttribute("href", url);
        document.getElementById("download").click();
        this.showDownloadSuccessAlert();
        this.loading = false;
      },
      () => {
        this.showErrorAlert();
        this.loading = false;
      }
    );
  }



  getDynamicSuccessMessage(): string {
    if (this.request.receipts.length === 1) {
      return "El comprobante se envió con éxito, se enviará un mail para ser aprobada por el Operador de Banco";
    }
      return "Los comprobantes se enviaron con éxito, se enviará un mail para ser aprobada por el Operador de Banco";
  }

  canShowReceiptsManagment(): boolean {
    if(this.error != null){
      let sumAmount = 0; 
      this.request.receipts.forEach((receipt) => sumAmount += receipt.amount )
      if (+parseFloat(sumAmount.toFixed(2)) !== this.request.amount) {
        this.error = constants.alerts.receipts.nonMatchingAmounts;
        
      }else{
        this.error = null;
      }  

    }
    
    return (
      (this._auth.user.hasRole(1201) ||
        this._auth.user.hasRole(1203) ||
        this._auth.user.hasRole(1204)) &&
      !this.request.isRRBB()
    );
  }

  canShowButtonRejectedForState(state:string): boolean {
    
    return(state != 'PENDIENTE');
       
  }

  // SWAL
  showRejectAlert(): Promise<boolean> {
    return Swal.fire({
      html:
        "<p class='alert-question'>¿Estás seguro que deseas rechazar la siguiente solicitud?</p>" +
        `<h3>${this.request.name}</h3>`,
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
      showClass: {
        popup: "animated fadeIn fast",
      },
      hideClass: {
        popup: "animated fadeOut fast",
      },
      customClass: {
        closeButton: "close-button-class",
        confirmButton: "confirm-button-class",
        cancelButton: "cancel-button-class",
      },
    }).then((result) => (result.value ? true : false));
  }

  showDownloadSuccessAlert() {
    Swal.fire({
      showClass: {
        popup: "animated fadeIn fast",
      },
      hideClass: {
        popup: "animated fadeOut fast",
      },
      showCloseButton: true,
      html:
        "<p class='alert-question'>Se descargó exitosamente la planilla de</p>" +
        `<h3>La solicitud ${this.request.name}</h3>`,
      icon: "success",
      confirmButtonText: "Cerrar",
      customClass: {
        closeButton: "close-button-class",
        confirmButton: "confirm-button-class",
      },
    });
  }

  showErrorAlert() {
    Swal.fire({
      showClass: {
        popup: "animated fadeIn fast",
      },
      hideClass: {
        popup: "animated fadeOut fast",
      },
      showCloseButton: true,
      html:
        "<p class='alert-question'>Ha ocurrido un error en la descarga de la planilla</p>" +
        "<p>Puedes volver a intentarlo</p>",
      icon: "error",
      confirmButtonText: "Cerrar",
      customClass: {
        closeButton: "close-button-class",
        confirmButton: "confirm-button-class",
      },
    });
  }
}
